import { Stack, StackProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(Stack)<StackProps>(
  ({ theme: { spacing, palette, customVars } }) => ({
    gap: spacing(3.2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 'fit-content',
    padding: spacing(1.4, 1.6),
    marginBottom: spacing(0.2),
    backgroundColor: palette.common.white,
    boxShadow: customVars.dropDownShadow,
    '& .phone-number': {
      minWidth: spacing(30),
    },
    '& .date': {
      minWidth: spacing(35),
    },
    '& .number-type': {
      minWidth: spacing(15),
      textAlign: 'right',
    },
    '& .enable-number': {
      minWidth: spacing(13),
      marginLeft: 'auto',
      color: palette.text.primary,
    },
    '& .delete-icon': {
      color: palette.text.primary,
    },
  })
);
